import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { DateTime } from "luxon";
import { TypeTraining } from '../../../services/models';
import ViewedFlag from '../../../components/Training/ViewedFlag';

interface Props {
  training: TypeTraining;
  className?: string;
}

interface StylesProps {
  image: string;
}

const TrainingCard = ({ training, className }: Props) => {
  const classes = useStyles({ image: training.image });
  const luxonDate = DateTime.fromISO(training.createdDate.toString()).setLocale('pt-BR').toLocaleString();

  return (
    <Link to={`/treinamento/${training.id}`}>
      <Box className={[classes.container, className].join(' ')}>
        <Typography variant="h4">{training.title}</Typography>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={5} sm={4} lg={6}>
            <Typography id="training-date">{luxonDate}</Typography>
          </Grid>
          <Grid container item xs={7} sm={8} lg={6} justify="flex-end">
            <ViewedFlag viewed={training.viewed} />
          </Grid>
        </Grid>
      </Box>
    </Link>
  );
}

export default TrainingCard;

const useStyles = makeStyles<Theme, StylesProps>((theme) =>
  createStyles({
    container: {
      minHeight: 215,
      padding: theme.spacing(1),
      background: ({ image }) => `center / cover no-repeat url(${image})`,
      borderRadius: 16,

      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',

      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(2),
      },

      '& h4': {
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
        textShadow: '1px 2px 2px #0000006b',
      },

      '& p#training-date': {
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.pxToRem(12),
        textShadow: '1px 1px 2px #0000006b',
      },
    },
  })
);